module.exports = __webpack_public_path__ + "img/yes-button_hover.3a9ca904.png";